import { createContext, useContext } from 'react';
import { CONFIG } from '@frontend/config';

export const HotelAgencyContext = createContext(Number(CONFIG.AGENCY_ID));
export const useHotelAgency = () => useContext(HotelAgencyContext);

export const HotelSalesAgencyContext = createContext<number | undefined>(undefined);
export const useHotelSalesAgency = () => useContext(HotelSalesAgencyContext);
